import { Component } from 'react';
import { withIdleTimer } from 'react-idle-timer';

class IdleTimerComponent extends Component<any, any> {
    render() {
        return this.props.children;
    }
}

export const IdleTimer = withIdleTimer<any>(IdleTimerComponent);
